import getApplicationConfig from '../common/config'
import { isEpnApp } from '../van-shared/utils/utils'

export const loadFavicon = () => {
  const config = getApplicationConfig(window.location.href)

  const oldFavicon = document.querySelector("link[rel~='icon']")
  const link = document.createElement('link')
  const faviconUrl = `${window.location.origin}/${config.theme}/favicon.ico`
  link.rel = 'icon'
  link.href = faviconUrl
  if (oldFavicon) {
    document.head.removeChild(oldFavicon)
  }
  document.head.appendChild(link)

  if (isEpnApp(config)) {
    document.title = config.title
  }
}
